import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import '../styles/components/modal.css'
import { useI18n } from '../i18n'

export default function Modal({ open, title, titleId = 'modal-title', onClose, children, footer, modalClassName }) {
  const { t } = useI18n()

  useEffect(() => {
    if (open) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      const prevOverflow = document.body.style.overflow
      const prevPaddingRight = document.body.style.paddingRight
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollbarWidth ? `${scrollbarWidth}px` : ''
      return () => {
        document.body.style.overflow = prevOverflow
        document.body.style.paddingRight = prevPaddingRight
      }
    }
  }, [open])

  if (!open) return null

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={['modal', modalClassName].filter(Boolean).join(' ')}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="modal-header">
          <h2 id={titleId} className="modal-title">
            {title}
          </h2>
          <button
            type="button"
            className="modal-close"
            aria-label={t('common.close')}
            onClick={onClose}
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M18 6L6 18" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="modal-content">{children}</div>
        {footer ? <div className="modal-footer">{footer}</div> : null}
      </div>
    </div>,
    document.body,
  )
}
